import { useFormContext } from 'react-hook-form';
import { ACTUAL_VALUES, EXPECTED_VALUES, toDisplayName } from './constants';
import * as React from 'react';
import { TextInput } from 'react-admin';
import { Button, Grid, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { useState, useEffect, useMemo } from 'react';

export const CompareExpectedToActualValuesStep = () => {
	const { getValues, setValue } = useFormContext();
	const [hasNewValue, setHasNewValue] = useState<any>({});

	useEffect(() => {
		const allFormValues = getValues();
		const newHasNewValue = {};
		for (const actualValueKey of ACTUAL_VALUES) {
			const expectedValueKey = actualValueKey.replace(
				'actual',
				'expected'
			);
			const isMeaningfulValue =
				allFormValues[actualValueKey] !== undefined &&
				allFormValues[actualValueKey] !== '' &&
				!allFormValues[actualValueKey].startsWith('Error: ');
			// @ts-ignore
			newHasNewValue[actualValueKey] =
				allFormValues[actualValueKey] !==
					allFormValues[expectedValueKey] && isMeaningfulValue;
		}
		setHasNewValue((prevState: any) => ({ ...prevState, ...newHasNewValue }));
	}, [getValues]);

	const onUseFoundExpectedValue = (actualValueKey: string) => {
		const allFormValues = getValues();
		const expectedValueKey = actualValueKey.replace('actual', 'expected');
		setValue(expectedValueKey, allFormValues[actualValueKey]);
		setHasNewValue((prevState: any) => ({
			...prevState,
			[actualValueKey]: false
		}));
	};

	const onUseAllFoundExpectedValues = () => {
		const valuesToUse: string[] = [];
		for (const actualValueKey of ACTUAL_VALUES) {
			if (hasNewValue[actualValueKey] === true) {
				valuesToUse.push(actualValueKey);
			}
		}
		for (const v of valuesToUse) {
			onUseFoundExpectedValue(v);
		}
	}

	const noValuesToImprove = useMemo(() => {
		for (const actualValueKey of ACTUAL_VALUES) {
			if (hasNewValue[actualValueKey] === true) {
				return false;
			}
		}
		return true;
	}, [hasNewValue]);

	return (
		<>
			<Typography>
				Vergleiche die erwarteten Werte mit den im vorherigen Schritt
				tatsächlich gefundenen.
			</Typography>
			{noValuesToImprove && (
				<Typography>
					Alle erwarteten Werte sind bereits optimal gesetzt 😀
				</Typography>
			)}
			{!noValuesToImprove && (
				<Button onClick={() => onUseAllFoundExpectedValues()}>
					Alle übernehmen
				</Button>
			)}
			<Grid
				container
				spacing={1}
				justifyContent='center'
				sx={{
					'& .MuiFormControl-root': { width: '100%' },
					'& .MuiInputBase-root': {
						color: '#000000de',
						backgroundColor: '#0000000a !important',
						'& input': { WebkitTextFillColor: 'black' }
					}
				}}
			>
				{ACTUAL_VALUES.map((actualValueKey, i) => {
					const expectedValueKey = EXPECTED_VALUES[i];
					const displayName = toDisplayName(actualValueKey);

					return (
						<React.Fragment key={actualValueKey}>
							<Grid
								item
								xs={5}
								display='flex'
								alignItems='flex-start'
								justifyContent='center'
							>
								<TextInput
									label={`Tatsächlicher Wert für ${displayName}`}
									source={actualValueKey}
									disabled
								/>
							</Grid>
							<Grid
								item
								xs={1}
								display='flex'
								alignItems='center'
								justifyContent='center'
							>
								<Button
									variant='contained'
									color='primary'
									onClick={() =>
										onUseFoundExpectedValue(actualValueKey)
									}
									disabled={!hasNewValue[actualValueKey]}
									aria-label={`Tatsächlichen Wert für ${displayName} übernehmen`}
									sx={{ minWidth: 0, px: 1.5 }}
								>
									<ArrowForwardIcon />
								</Button>
							</Grid>
							<Grid
								item
								xs={5}
								display='flex'
								alignItems='flex-end'
								justifyContent='center'
							>
								<TextInput
									label={`Erwarteter Wert für ${displayName}`}
									source={expectedValueKey}
									disabled
								/>
							</Grid>
						</React.Fragment>
					);
				})}
			</Grid>
		</>
	);
};
